<template>

    <!-- otherwise when we have fresh empty or missing phones.json, we can't enter but parent can have this, when a configurations is expected   v-if="currentSelectedConfiguration && currentSelectedConfigurationIndex > -1 && Object.keys(configurations[currentSelectedConfigurationIndex].value.phone_model).length < 1"-->
    <v-row>

        <!--                    <v-card class="px-10 overflow-y-auto" :class="{'fill-height': !selectedTemplate}">-->
        <v-col class="mt-3 ml-3 text-left" cols="12" md="6">

            <snackbar ref="snackbar" />

            <div class="mb-6 text-h5">
                <v-icon v-text="icons.mdiCellphoneCog"></v-icon>
                {{ currentSelectedConfiguration }}
            </div>

            <div v-if="!$props.chosenModel || !$props.chosenModel.length" class="text-left mb-3"
                v-text="$gettext('Let\'s add the phone model to this configuration.')"></div>

            <v-slide-x-transition>
                <v-autocomplete v-model="chosenModelAutocomplete" :disabled="downloadingPhoneIconsProgressBar"
                    :error-messages="chosenModelAutocompleteErrors"
                    :hint="downloadingPhoneIconsProgressBar ? 'Downloading phone icons...' : ''" :items="phoneTypes"
                    :label="$gettext('Phone model')" :loading="downloadingPhoneIconsProgressBar"
                    :persistent-hint="downloadingPhoneIconsProgressBar"
                    :placeholder="$gettext('Please choose a phone model')" item-text="key" item-value="key" outlined
                    @blur="$v.chosenModelAutocomplete.$touch()" @change="phoneModelChange(chosenModelAutocomplete)"
                    @input="$v.chosenModelAutocomplete.$touch()"></v-autocomplete>
            </v-slide-x-transition>


            <v-slide-x-transition>
                <v-autocomplete v-if="filteredList && chosenModelAutocomplete" v-model="selectedTemplate"
                    :items="templateList" :label="$gettext('Phone template')"
                    :placeholder="$gettext('Please choose a template')" item-text="text" item-value="value" outlined
                    @change="changeTemplate"></v-autocomplete>
            </v-slide-x-transition>


            <v-slide-y-reverse-transition>
                <v-btn v-if="selectedTemplate" :disabled="!selectedTemplate" color="primary"
                    @click="addDeviceToConfiguration()" v-text="$gettext('Add Device')"></v-btn>
            </v-slide-y-reverse-transition>

        </v-col>

        <v-col v-if="selectedTemplate">
            <div :class="{ 'smartphone-border': !isDark, 'smartphone-border-dark': isDark }"
                class="smartphone smartphone-width">
                <div class="device-name">LightPhone</div>
                <div :class="{ 'smartphone-content-background': !isDark, 'smartphone-content-background-dark': isDark }"
                    class="smartphone-content smartphone-content-height overflow-y-auto">
                    <div class="mt-6">
                        <draggable v-model="templateAppList" :group="'apps'"
                            :options="{ disabled: $vuetify.breakpoint.smAndDown }" class="app-grid top-app-grid"
                            @change="removeDuplicatePackageForCurrentConfiguration">

                            <!--                            @openAddEditAppDialog="(val) => openAddEditAppDialog(val)"-->
                            <app-icon v-for="(phone, key) in templateAppList" :key="phone.packageId"
                                :app-name="phone.appName ? phone.appName : phone.appName"
                                :device-name="chosenModelAutocomplete" :folder-name="folderName" :group="'apps'"
                                :is-show="!phone.isFavorite"
                                :package-name="phone.packageId ? phone.packageId : phone.packageId" :showMenu="showMenu"
                                :x="x" :y="y" @changeShowMenu="(val) => updateShowMenu(val, phone.packageId)" />

                        </draggable>
                    </div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>
<script>

import { mapWritableState } from "pinia";
import { usePhonesStore } from "@/stores/PhonesStore";
import MixinIcon from "@/mixins/MixinIcon";
import { required } from 'vuelidate/lib/validators'
import { usePhoneTypesStore } from "@/stores/PhoneTypesStore";
import { findIndex } from "lodash";
import Snackbar from "@/components/Snackbar.vue";
import MixinMobileAppsStoreDevice from "@/mixins/mobile_apps/MixinMobileAppsStoreDevice";
import draggable from 'vuedraggable'
import AppIcon from "@/components/devices/AppIcon.vue";
import MixinMobileLeftStoreDevice from "@/mixins/mobile_apps/MixinMobileLeftStoreDevice";
import MixinDark from "@/mixins/database/MixinDark";
import axios from "axios";

export default {
    components: { AppIcon, Snackbar, draggable },

    props: {
        chosenModel: {
            type: String | Object,
            default: '',
        },
    },
    mixins: [MixinIcon, MixinMobileAppsStoreDevice, MixinMobileLeftStoreDevice, MixinDark],

    data() {
        return {
            chosenModelAutocomplete: '',
            selectedTemplate: null,
            templateList: [],
            templateAppList: [],
            filteredList: null,
            folderName: '',
            /**
             * We are having this over here instead of in the child component because otherwise the earlier opened menus are kept open. We needed something that is not just common to all appIcons but dynamic as well. In the future, this should be improved and simplified but for now this works, and we will circle back on this soon.
             */
            showMenu: { value: false, packageName: '' },
            x: 0,
            y: 0,
            downloadingPhoneIconsProgressBar: false,
        }
    },

    computed: {


        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
        }),
        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',
            appsCommon: 'appsCommon',
        }),
        chosenModelAutocompleteErrors() {

            const errors = []
            if (!this.$v.chosenModelAutocomplete.$dirty) return errors
            !this.$v.chosenModelAutocomplete.required && errors.push(this.$gettext('Please select a phone model.'))
            return errors

        }

    },

    methods: {

        /**
         *
         * TODO: Make a mixin of the method
         *
         * Not that it is significant but know that this is being called twice by AppIcon
         * @param val
         * @param packageName
         */
        updateShowMenu(val, packageName) {

            let self = this

            // TODO: This if is no help, remove it.
            if (val.packageName === packageName) {

                self.$set(this.showMenu, 'value', val.value)
                self.$set(this.showMenu, 'packageName', val.packageName)

                self.x = val.x
                self.y = val.y

            }

        },

        phoneModelChange(val) {

            const self = this

            self.storePhoneIconsIfMissing(val)

            self.nullTemplateFields()

            self.folderName = self.getPhoneTypeDirForDevice()
            self.$emit('update-folder-name', self.folderName)

            self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModelAutocomplete })
            let phoneTypeIndex = self.phoneTypeIndex;

            self.$emit('update-phone-type-index', phoneTypeIndex)

            self.filteredList = self.phoneTypes[phoneTypeIndex].value.applications
            self.templateList = Object.keys(self.phoneTypes[phoneTypeIndex].value.applications)
            /*?.filter(i => i !== 'xxdisabledxx all applications')*/

            self.templateList = self.templateList.map(templateName => {

                let templateText = templateName, finalTemplateText = ''

                templateText.split(' ').forEach((templateNamePart, index) => {

                    let firstLetterUpperCase = templateNamePart.charAt(0).toUpperCase() + templateNamePart.slice(1)
                    finalTemplateText += !index ? firstLetterUpperCase : ' ' + firstLetterUpperCase

                })

                return {
                    text: finalTemplateText,
                    value: templateName
                }

            })

            self.templateList.push({
                text: 'Empty',
                value: 'empty'
            })

            self.$emit('update-chosen-model', self.chosenModelAutocomplete)


        },

        nullTemplateFields() {
            const self = this
            self.filteredList = null
            self.templateList = null
            self.folderName = null
            self.selectedTemplate = null
            self.$emit('update-selected-template', self.selectedTemplate)
        },

        async storePhoneIconsIfMissing(phoneModel) {

            /*---------------------------------------------
                We are disabling this as rsync handles the icons now
            ----------------------------------------------*/

            return true;

            if (phoneModel.toLowerCase() === 'all') {
                return
            }

            const self = this
            self.downloadingPhoneIconsProgressBar = true;

            let dir = '';

            const phoneTypeIndex = self.phoneTypes.findIndex((phoneType) => {
                return phoneType.key === phoneModel;
            })

            if (phoneTypeIndex > -1) {
                dir = self.phoneTypes[phoneTypeIndex].value.dir
            } else {
                console.error('Phone type not found')
            }

            await axios.get(`mobile_apps.php?phone_model=${phoneModel}&dir=${dir}`)
                .then(response => {

                    if (response.data.status) {

                        /**
                         * Q. Why we are doing this here (and again, as caller does this as well)?
                         * A. To refresh app icons, so that the downloaded icons are shown, as they are downloaded (& available).
                         */

                        self.folderName = self.getPhoneTypeDirForDevice()
                        self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModelAutocomplete })
                        self.$emit('update-folder-name', self.folderName)
                        self.$emit('update-phone-type-index', self.phoneTypeIndex)

                    } else if (!response.data.status && response.data.errorCode === 'phone_model_dir_missing') {
                        // No need to show any error here as no functionalities are affected by this
                    } else if (!response.data.status && response.data.errorCode === 'phone_types_missing') {
                        // No need to show any error here as no functionalities are affected by this
                    } else {

                    }

                })
                .catch(error => {
                    console.error(error)
                }).finally(() => {
                    self.downloadingPhoneIconsProgressBar = false;
                })

        },

        changeTemplate() {

            const self = this

            if (self.selectedTemplate === 'empty') {
                self.templateAppList = []
            } else {
                self.templateAppList = self.filteredList[self.selectedTemplate]
            }

            self.$emit('update-selected-template', self.selectedTemplate)

        },


        addDeviceToConfiguration() {

            let self = this
            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.configurations[self.currentSelectedConfigurationIndex].value.phone_model = self.chosenModelAutocomplete
                self.$set(self.configurations[self.currentSelectedConfigurationIndex].value, 'applications', JSON.parse(JSON.stringify(self.templateAppList)))
                self.chosenModel = self.chosenModelAutocomplete
                self.$emit('update-chosen-model', self.chosenModel)
                self.chosenModelAutocomplete = ''
                self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModel })

                self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('%{ model } added successfully for %{configuration}'), {
                    model: self.chosenModel,
                    configuration: self.currentSelectedConfiguration
                }), 'success')

                self.$emit('device-added-successfully')

            }

        }
    },
    validations: {
        chosenModelAutocomplete: {
            required,
        },
    }
}

</script>
<style type="text/scss">
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {

    .app-grid {
        text-align: center;
    }

    .border-right-divider {
        border-right: 1px solid #e0e0e0;
    }

    .top-app-grid {
        height: 480px;
    }

    .top-app-grid-with-search {
        height: 380px;
    }

    .row.template_row {
        display: flex;
        flex-direction: column;
        align-self: baseline;
    }

    /*
    .smartphone-content::before {
        content: "Lightphone";
        width: 100px;
        color: grey;
        left: 10px;
        position: absolute;
        top: -41px;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 14px;
    } */
    .device-name {
        content: "LightPhone";
        width: 100px;
        color: white;
        left: 10px;
        position: absolute;
        top: -41px;
        font-weight: bold;
        /*letter-spacing: 1px;*/
        font-size: 14px;
    }

    .top-app-grid {
        //height: 334px; height: 430px; overflow-y: scroll;
    }

    .app-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        grid-template-rows: repeat(6, 1fr);
        row-gap: 20px;
        column-gap: 10px;
    }

    /*.app-grid-right {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        !* grid-template-rows: repeat(3, 1fr); grid-template-rows: repeat(6, 1fr); row-gap: 20px; column-gap: 10px; *!
    }*/

}


@import "../../../assets/scss/smartphone.css";
</style>
